<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://innovationplaza.it/#website",
      "url": "https://innovationplaza.it",
      "name": "Innovation Plaza — Consulenza per l'Innovazione",
      "description": "Supportiamo imprese, istituzioni e imprenditori nei processi di innovazione, strategia, accesso ai fondi europei e sviluppo imprenditoriale.",
      "inLanguage": "it-IT",
      "publisher": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://innovationplaza.it/?s={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "ContactPage",
      "@id": "https://innovationplaza.it/contatti/#webpage",
      "url": "https://innovationplaza.it/contatti/",
      "name": "Contatta Innovation Plaza",
      "description": "Contattaci per una consulenza su innovazione aziendale, fondi europei, bandi e sviluppo imprenditoriale. Risposta entro 24 ore lavorative.",
      "inLanguage": "it-IT",
      "isPartOf": {
        "@id": "https://innovationplaza.it/#website"
      },
      "about": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://innovationplaza.it/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Contatti",
            "item": "https://innovationplaza.it/contatti/"
          }
        ]
      },
      "mainEntity": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "info@innovationplaza.it",
        "telephone": "+39-02-49539510",
        "availableLanguage": [
          {
            "@type": "Language",
            "name": "Italian"
          },
          {
            "@type": "Language",
            "name": "English"
          }
        ],
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      }
    },
    {
      "@type": "Organization",
      "@id": "https://innovationplaza.it/#organization",
      "name": "Innovation Plaza",
      "url": "https://innovationplaza.it",
      "email": "info@innovationplaza.it",
      "telephone": "+39-02-49539510",
      "image": "https://innovationplaza.it/assets/og-image.jpg"
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-milano",
      "name": "Innovation Plaza — Sede legale e Nord Italia (Milano)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "telephone": "+39-02-49539510",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Viale Papiniano 44",
        "addressLocality": "Milano",
        "addressRegion": "MI",
        "postalCode": "20123",
        "addressCountry": "IT"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 45.4625,
        "longitude": 9.1710
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }],
      "priceRange": "$$",
      "currenciesAccepted": "EUR",
      "paymentAccepted": "Bonifico bancario, Fattura elettronica",
      "hasMap": "https://maps.google.com/?q=Viale+Papiniano+44+Milano+20123"
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-brindisi",
      "name": "Innovation Plaza — Sede Centro-Sud Italia (Brindisi)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "url": "https://innovationplaza.it",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Palazzo Guerrieri, Via Guerrieri 7",
        "addressLocality": "Brindisi",
        "addressRegion": "BR",
        "postalCode": "72100",
        "addressCountry": "IT"
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }]
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-cinisello",
      "name": "Innovation Plaza — Sede operativa Nord (Cinisello Balsamo)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Viale Fulvio Testi 11",
        "addressLocality": "Cinisello Balsamo",
        "addressRegion": "MI",
        "postalCode": "20092",
        "addressCountry": "IT"
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }]
    }
  ]
}
</script>

    <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
    style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

    <div class="mt-[60px] relative text-222222 text-font40px aspect43:text-center font-normal uppercase">
        <h1 class="text-font36px leading-[40px] font-extrabold mb-2.5 text-center">
            Domande, proposte o progetti? Contattaci
        </h1>
    </div>

    <div class="items-center mb-5 text-white font-normal text-font19px aspect43:text-font26px max-w-[100%] mx-auto flex">
        <div class="text-center text-justify-disabled mx-auto text-font24px font-normal leading-[25px]">
            Contattaci, il nostro team è pronto ad ascoltarti<br>
e offrirti il supporto che ti serve
        </div>
    </div>

    <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">
        <div class="text-font32px font-semibold text-[#222222] mb-12">Contatti diretti</div>
        <!-- <div class="text-font24px text-[#364349] mb-12">Accedi a bandi sempre aggiornati e scopri le opportunità più
            rilevanti per i tuoi obiettivi di innovazione, crescita o trasformazione.</div> -->
        <div class="flex flex-wrap gap-[52px] place-content-between">
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Sede legale</div>
                <div class="text-[#364349] text-font20px font-normal">Viale Papiniano 44, 20123 Milano – Italia</div>
            </div>
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Sedi operative</div>
                <div class="text-[#364349] text-font20px font-normal"><strong>NORD: </strong>Viale Fulvio Testi 11, 20092 Cinisello Balsamo (MI)</div>
                <div class="text-[#364349] text-font20px font-normal"><strong>SUD: </strong>Palazzo Guerrieri – Via Guerrieri 7, 72100 Brindisi (BR)</div>
            </div>
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Telefono</div>
                <div class="text-[#364349] text-font20px font-normal">+39 02 49539 510</div>
            </div>
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Email</div>
                <div class="text-[#364349] text-font20px font-normal">{{'info@innovationplaza.it'}}</div>
            </div>
        </div>
    </div>
    
    <div class="mt-[46px] bg-[#D3E0FF] w-full rounded-[20px] lg:flex gap-[84px] shadow-lg py-[39px] px-[30px]">
        <div class="lg:w-[calc(100%-542px)]">
            <div class="text-font32px font-bold text-[#222222]">Contattaci</div>
            <div class="text-font24px text-[#222222]">Hai una domanda, un'idea o un progetto da far crescere?</div>
            <div class="mt-6 text-font20px font-medium text-[#364349] text-justify">Siamo pronti ad ascoltarti. Compila il form o
                scrivici:
                il team di Innovation Smart Plaza è a tua disposizione per aiutarti a trovare la strada più efficace
                verso
                l'innovazione
            <div class="flex items-center gap-5 mt-6 mb-8">
        <a href="https://www.facebook.com/people/Innovation-Plaza/61556155897173/" target="_blank" rel="noopener noreferrer" class="hover:scale-110 transition-transform">
            <img src="../../assets/logoFacebook.png" alt="Facebook" class="w-12 h-12 object-contain">
        </a>

        <a href="https://www.linkedin.com/company/innovation-plaza-s-r-l/?originalSubdomain=it" target="_blank" rel="noopener noreferrer" class="hover:scale-110 transition-transform">
            <img src="../../assets/logoLinkedin.png" alt="Linkedin" class="w-10 h-10 object-contain">
        </a>    
    </div>

        <div class="w-full max-w-[360px] overflow-hidden rounded-[20px]">
            <img src="../../assets/CONTATTACI.jpg" alt="Innovation Smart Plaza Team" class="w-full h-auto object-contain">
        </div>
    </div>
</div>

        <div class="lg:w-[522px] mt-5 lg:mt-0 px-[24px] py-[43px] bg-white rounded-[20px]">
            <div class="border-[#283759] w-full border-[1px] h-[59px] rounded-[12px]">
                <input [(ngModel)]="contactForm.name" class="outline-none text-font18px font-medium placeholder:text-opacity-40 h-[57px] w-full px-3"
                    placeholder="Nome">
            </div>
            <div class="border-[#283759] w-full border-[1px] h-[59px] rounded-[12px] mt-4">
                <input [(ngModel)]="contactForm.email" class="outline-none text-font18px font-medium placeholder:text-opacity-40 h-[57px] w-full px-3"
                    placeholder="Email">
            </div>
            <div class="border-[#283759] w-full border-[1px] h-[153px] rounded-[12px] mt-4">
                <textarea [(ngModel)]="contactForm.message" style="resize: none"
                    class="outline-none text-font18px pt-3 bg-transparent font-medium placeholder:text-opacity-40 h-[151px] w-full px-3"
                    placeholder="Messaggio"></textarea>
            </div>
            <div (click)="sendEmail()" 
                class="text-white cursor-pointer bg-quintary w-[220px] h-[47px] ml-auto flex items-center place-content-center mt-6 text-font20px font-bold rounded-full" [ngClass]="{'opacity-35 pointer-events-none': !contactForm.name || !contactForm.email || !contactForm.message}">
                Invia Messaggio
            </div>
        </div>
    </div>

    <div class="mt-[46px] w-full shadow-lg pb-[58px] rounded-[20px] p-5 md:px-[96px] md:pt-[89px] bg-white">
        <div class="text-font32px font-bold text-[#222222]">Unisciti al team</div>
        <div class="mt-[21px] text-font24px font-medium text-[#364349] text-justify">Cresci con noi.<br>
            Siamo alla ricerca di persone curiose, competenti e appassionate, che credano
            nel potenziale della trasformazione digitale, nella finanza agevolata e nel valore
            delle connessioni. Se ti rivedi in questa visione:</div>
        <input class="hidden" type="file" id="upload-cv" (change)="changeInput($event)">
        <div class="md:flex ml-auto gap-5 md:w-fit mt-[28px]">
            <div (click)="openInput()"
                class="text-quintary cursor-pointer bg-white border-quintary border-[2px] w-full md:w-[238px] h-[47px] flex items-center place-content-center text-font20px font-bold rounded-full">
                Invia il tuo CV
            </div>
            <div (click)="openInput()"
                class="text-white cursor-pointer bg-quintary w-full mt-5 md:mt-0 md:w-[238px] h-[47px] flex items-center place-content-center text-font20px font-bold rounded-full">
                Invia Candidatura
            </div>
        </div>
    </div>
</div>

